import React, { memo } from 'react';
import { View } from 'react-native';
import { getOSIcon } from 'react-os-icons';
import { IconQuestion } from '@redlink/components/atoms';

const EmptyView = memo(({ size }) => <View style={{ width: size }} />);

export const IconOS = memo(({ size = 24, code, color }) => {
  return code === 'Other' ? (
    <IconQuestion {...{ size, color }} />
  ) : (
    <View>
      {getOSIcon({
        os: code,
        style: { width: size },
      }) || <EmptyView {...{ size }} />}
    </View>
  );
});
